import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Used1 from "../../assets/images/used01.png"
import Used2 from "../../assets/images/used02.png"
import Used3 from "../../assets/images/used03.png"
import Used4 from "../../assets/images/used04.png"
import Icon from "../../assets/images/play_icon.png"
import Appstore from "../../assets/images/appstore_blue.png"
import Appstorewhite from "../../assets/images/appstore_white.png"
import Blue from "../../assets/images/googleplay_blue.png"
import White from "../../assets/images/googleplay_white.png"


function Banner() {

    const [ytShow, setytShow] = useState(false);

    return (
        <>
            <section className="banner_section home-video-two">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-md-12" data-aos="fade-right" data-aos-duration="1500">
                            <div className="banner_text">
                                <h1>Experience the future of insurance protection today</h1>
                                <p>Lorem Ipsum is simply dummy text of the printing and setting indus orem Ipsum has been the industrys.
                                </p>
                            </div>
                            <ul className="app_btn">
                                <li>
                                    <Link to="#">
                                        <img className="blue_img" src={Appstore} alt="image" />
                                        <img className="white_img" src={Appstorewhite} alt="image" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <img className="blue_img" src={Blue} alt="image" />
                                        <img className="white_img" src={White} alt="image" />
                                    </Link>
                                </li>
                            </ul>

                            <div className="used_app">
                                <ul>
                                    <li><img src={Used1} alt="image" /></li>
                                    <li><img src={Used2} alt="image" /></li>
                                    <li><img src={Used3} alt="image" /></li>
                                    <li><img src={Used4} alt="image" /></li>
                                </ul>
                                <p>12M + <br /> used this app</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-12" data-aos="fade-in" data-aos-duration="1500">
                            <div className="banner_image">
                                <div className="yt_video" >
                                    <div className="thumbnil">
                                        <a className="popup-youtube play-button" onClick={() => setytShow(true)} data-url="#" data-toggle="modal" data-target="#myModal" title="XJj2PbenIsU">
                                            <span className="play_btn">
                                                <img src={Icon} alt="image" />
                                                <div className="waves-block">
                                                    <div className="waves wave-1"></div>
                                                    <div className="waves wave-2"></div>
                                                    <div className="waves wave-3"></div>
                                                </div>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {ytShow &&
                <>
                    <div className="modal fade youtube-video show" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true" style={{ paddingRight: "17px", display: "block" }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <button id="close-video" type="button" className="button btn btn-default text-right" data-dismiss="modal">
                                    <i className="icofont-close-line-circled" onClick={() => setytShow(false)}></i>
                                </button>
                                <div className="modal-body">
                                    <div id="video-container" className="video-container">
                                        <iframe id="youtubevideo" src="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&amp;mute=1" width="640" height="360" frameBorder="0" allowFullScreen=""></iframe>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="purple_backdrop"></div>
                </>
            }
        </>
    )
}

export default Banner